import React, {useRef, useState} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import {Auth} from 'aws-amplify';
import {toast} from 'react-toastify';
import Progress from '../components/Progress';
import ResetPassword from './ResetPassword';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Link as ExternalLink } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  'paper': {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  'avatar': {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  'form': {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  'submit': {
    margin: theme.spacing(2, 0, 1),
  },
}));

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <ExternalLink color="inherit" href="https://www.wbw.org/">
        Washington Business Week
      </ExternalLink>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const Login = (props) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [pwdErrorText, setPwdErrorText] = useState('');

  const [resetCodeScreen, setResetCodeScreen] = useState(false);

  const backToLoading = () => {
    setResetCodeScreen(false);
  };

  const classes = useStyles();

  const emailRef = useRef();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!email) {
      setErrorText('Email is required');
      return;
    }

    setErrorText('');

    if (!password) {
      setPwdErrorText('Password is required');
      return;
    }

    setPwdErrorText('');

    try {
      setLoading(true);
      // if (process.env.NODE_ENV === 'development') {
      //   Auth.configure({
      //     Auth: {
      //         region: 'us-east-1',
      //         userPoolId: 'us-east-1_ALfs6XSSx',
      //         userPoolWebClientId: 'cbl3u7ork2nt5jpakgrlltuib',
      //     },
      //   });
      // } else {
        Auth.configure({
          Auth: {
              region: 'us-west-2',
              userPoolId: 'us-west-2_cq0bxBlsQ',
              userPoolWebClientId: '3ln3vv6lgi6c08a64qio9ull3o',
          },
        });
      // }
      console.log('Auth configured with ', process.env.NODE_ENV);
      await Auth.signIn(email.toLowerCase(), password);
    } catch (e) {
      if (e.name === 'PasswordResetRequiredException'){
        toast.error('Password Reset Required.')
        props.history.push('/');

      } else if (e.name === 'UserNotFoundException' ||
        e.name === 'NotAuthorizedException' ) {
        toast.error('Invalid email or password');
        props.history.push('/');
      }

      return;
    } finally {
      setEmail('');
      setPassword('');
      setLoading(false);

      emailRef.current && emailRef.current.focus();
    }

    if (props.onLogin) {
      props.onLogin();
    }
  };



  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      {resetCodeScreen === false ? (

        <div className={classes.paper} style={{marginTop: 200}}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>

            <Typography component="h1" variant="h5">
          Sign in to WBW
            </Typography>
          </div>
          <form className={classes.form} noValidate onSubmit={handleSubmit}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              error={Boolean(errorText)}
              helperText={errorText}
              id="email"
              label="Email Address"
              name="email"
              type="email"
              autoComplete="username"
              autoFocus
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              inputRef={emailRef}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              error={Boolean(pwdErrorText)}
              helperText={pwdErrorText}
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
            />
            <Button
              onClick={handleSubmit}
              fullWidth
              type="submit"
              variant="contained"
              color="primary"
              className={classes.submit}
              disabled={loading}
            >
            Sign In
              {loading && <Progress variant="overlay" size='1.5em' />}
            </Button>
            <Grid container>
              <Grid item xs>
                <Link variant="body2" to="/reset">
                Forgot password?
                </Link>
              </Grid>
            </Grid>
          </form>
        </div>
      ) : (
        <ResetPassword backToLoading={backToLoading} />
      )}
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
};

Login.propTypes = {
  onLogin: PropTypes.func,
  history: PropTypes.object
};

export default Login;
